export type PublicLinkKind =
  | 'content'
  | 'content-categories'
  | 'collections'
  | 'collection-types';

// Builds a host-relative public URL (e.g. http://localhost:5173/public/content/abc).
// Backend still stores TinyURL on public.athleteera.app for the DB record, but
// the UI displays/copies/opens links scoped to whatever host the user is on.
export function buildPublicUrl(
  kind: PublicLinkKind,
  referenceId: string | undefined | null,
): string {
  if (!referenceId) return '';
  return `${window.location.origin}/public/${kind}/${referenceId}`;
}
